






















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getUnitVideos, getUnitList } from '@/api/videoDevice/play'
import FormDialog from '@/components/dialog/formDialog.vue'

@Component({
  components: {
    FormDialog
  }
})
export default class SearchVideoPoint extends Vue {
  public name = 'SearchVideoPoint'

  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void

  //表示从哪个组件过来的，回发的时候带上
  public refTarget: string = ''

  public showDialog: boolean = false
  public listLoading: boolean = false
  public list: any[] = []
  public queryTerm: any = {
    Page: 0,
    PageSize: 999,
    SortBy: 'UnitName',
    IsAsc: false,

    OnlineStatus: 0,
    Keyword: ''
  }

  public mounted() {
    window.eventBus.$on("openSearchVideoPoint", (targetId: string) => {
      this.refTarget = targetId
      this.open()
      this.doSearch()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openSearchVideoPoint")
  }
  public open() {
    this.showDialog = true
    //重置控件
    this.queryTerm = {
      Page: 0,
      PageSize: 999,
      SortBy: 'UnitName',
      IsAsc: false,

      OnlineStatus: 0,
      Keyword: ''
    }
  }
  public close() {
    this.showDialog = false
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  // 查询用户所在地的文保单位
  public doSearch() {
    this.queryTerm.Page = 1
    this.list = []
    this.fetchData()
  }

  public expandKey1: number[] = []
  public fetchData() {
    this.listLoading = true
    this.expandKey1 = []
    getUnitList(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        var items = data.Results
        items.forEach((e: any, i: number) => {
          e.checked = false
        })
        this.list = items

        //页面首次加载时，默认打开第一个节点
        if (this.expandKey1.length == 0 && items.length > 0) {
          var row = items.find((v: any) => v.OnlineCount > 0)// units[0]
          if (row && row.UnitId > 0) {
            this.expandKey1 = [row.UnitId]
            this.fetchVideo(row, null)
          }
        }
      }
      this.listLoading = false
    })
  }
  public fetchVideo(row: any, expandedRows: any) {
    if (!row.childs || row.childs.length == 0) {
      row.childs = []
      row.loading = true
      getUnitVideos(row.UnitId, 0).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          data.forEach((e: any, i: number) => {
            e.checked = false
          })
          row.childs = data
          row.loading = false
          var index = this.list.findIndex((v: any) => v.UnitId == row.UnitId)
          this.$set(this.list, index, row)
        }
      })
    }
  }
  public checkAll(index: number) {
    var item = this.list[index]
    item.childs.forEach((e: any, i: number) => {
      e.checked = item.checked
    })
  }
  public getItems() {
    var items: any[] = []
    this.list.forEach((e: any, i: number) => {
      if (e.childs && e.childs.length > 0) {
        var childs = e.childs.filter((v: any) => v.checked)
        if (childs && childs.length > 0) {
          childs.forEach((f: any, j: number) => {
            items.push(f)
          })
        }
      }
    })
    var count = items.length
    if (count == 0) {
      this.$message.warning('请选择监控点')
    }
    else {
      this.sendData(items)
      this.showDialog = false
    }
  }
  public sendData(data: any[]) {
    // console.log(this.refTarget, data)
    window.eventBus.$emit("submitSearchVideoPoint", {
      targetId: this.refTarget,
      data: data
    })
  }
}
